import { render, staticRenderFns } from "./StickerPicker.vue?vue&type=template&id=70ea3844&scoped=true"
import script from "./StickerPicker.vue?vue&type=script&lang=js"
export * from "./StickerPicker.vue?vue&type=script&lang=js"
import style0 from "./StickerPicker.vue?vue&type=style&index=0&id=70ea3844&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ea3844",
  null
  
)

export default component.exports